const bannerDate = '03-21'; // CHANGE THE DATE for new surveys

export const keySeen = `_bannerSurveySeen-${bannerDate}`;
export const keyClicked = `_bannerSurveyClicked-${bannerDate}`;
